import type { CatalogEvent } from "@/features/catalog/mediators/catalogEvents";
import { createMediator, type Mediator } from "@/shared/lib/componentHierarchy";

type CatalogToolbarState = { readonly isTagFilterExpanded: boolean };
export type CatalogToolbarEvent = Extract<
  CatalogEvent,
  {
    type:
      | "catalog/toolbar-filter-toggled"
      | "catalog/sort-selected"
      | "catalog/auto-reload-changed"
      | "catalog/refresh-requested"
      | "catalog/sidebar-toggle-requested"
      | "catalog/scroll-requested";
  }
>;
export type CatalogToolbarEffect = Exclude<
  CatalogToolbarEvent,
  { type: "catalog/toolbar-filter-toggled" }
>;

export function isCatalogToolbarEvent(
  event: CatalogEvent,
): event is CatalogToolbarEvent {
  return (
    event.type === "catalog/toolbar-filter-toggled" ||
    event.type === "catalog/sort-selected" ||
    event.type === "catalog/auto-reload-changed" ||
    event.type === "catalog/refresh-requested" ||
    event.type === "catalog/sidebar-toggle-requested" ||
    event.type === "catalog/scroll-requested"
  );
}

export function createCatalogToolbarMediator(
  canHandle: (event: CatalogToolbarEffect) => boolean = () => false,
  runEffect: (event: CatalogToolbarEffect) => void = (): void => undefined,
): Mediator<CatalogToolbarState, CatalogToolbarEvent, CatalogToolbarEffect> {
  return createMediator<
    CatalogToolbarState,
    CatalogToolbarEvent,
    CatalogToolbarEffect
  >(
    { isTagFilterExpanded: false },
    (state, event) => {
      if (event.type === "catalog/toolbar-filter-toggled") {
        return {
          status: "handled",
          state: { isTagFilterExpanded: !state.isTagFilterExpanded },
        };
      }
      return canHandle(event)
        ? { status: "handled", state, effects: [event] }
        : { status: "unhandled", state };
    },
    { runEffect },
  );
}
